import React, { useState } from "react";
import { Modal, Form, Button, Spinner } from "react-bootstrap";

interface SaveReportModalProps {
  show: boolean;
  onHide: () => void;
  onSave: (name: string, description: string) => Promise<void>;
}

const SaveReportModal: React.FC<SaveReportModalProps> = ({
  show,
  onHide,
  onSave,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      await onSave(name.trim(), description.trim());
      setName("");
      setDescription("");
      onHide();
    } catch {
      // error handled by caller
    } finally {
      setSaving(false);
    }
  };

  const handleExited = () => {
    setName("");
    setDescription("");
  };

  return (
    <Modal show={show} onHide={onHide} onExited={handleExited} centered>
      <Modal.Header>
        <Modal.Title style={{ fontSize: "1rem" }}>
          Save Report Bookmark
        </Modal.Title>
        <button
          type="button"
          onClick={onHide}
          aria-label="Close"
          style={{
            background: "transparent",
            border: "none",
            fontSize: "1.4rem",
            lineHeight: 1,
            cursor: "pointer",
            padding: "4px 8px",
            color: "var(--text-strong)",
            opacity: 0.5,
          }}
        >
          &times;
        </button>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label style={{ fontSize: "0.85rem", fontWeight: 600 }}>
            Name <span style={{ color: "var(--status-danger)" }}>*</span>
          </Form.Label>
          <Form.Control
            size="sm"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Monthly Enrollment by School"
            autoFocus
          />
        </Form.Group>
        <Form.Group>
          <Form.Label style={{ fontSize: "0.85rem", fontWeight: 600 }}>
            Description
          </Form.Label>
          <Form.Control
            size="sm"
            as="textarea"
            rows={2}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Optional description"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          size="sm"
          onClick={onHide}
          disabled={saving}
          style={{ padding: "4px 16px", fontSize: "0.85rem" }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={handleSave}
          disabled={!name.trim() || saving}
          style={{ padding: "4px 16px", fontSize: "0.85rem" }}
        >
          {saving ? (
            <Spinner role="status" animation="border" size="sm" />
          ) : (
            "Save"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveReportModal;
